import React, {Component, useState, useEffect} from 'react';
import AddressSearchBar from '../../addressSearchBar/js/AddressSearchBar.jsx';
import GoogleMapReact from 'google-map-react';
import getGoogleApi from '../../../../global/helpers/getGoogleApiKey';
import DirectionSteps from './DirectionSteps.jsx';

const DirectionModalBlock = (props) => {
	const [map, setMap] = React.useState(null);
	const [walkingDisplay, setWalkingDisplay] = React.useState(null);
	const [drivingDisplay, setDrivingDisplay] = React.useState(null);
	const [directionsService, setDirectionsService] = React.useState(null);
	const [directionInstructions, setDirectionInstructions] = React.useState({});
	const [drivingSteps, setDrivingSteps] = React.useState({});
	const [walkingSteps, setWalkingSteps] = React.useState({});


	React.useEffect(() => {
		if (map && props.mapVisible) {
			// add a small delay for map de-bouncing
			setTimeout(() => {
				drawDirections();
			}, 500);
		}
	}, [
		props.origCoords,
		props.destinationCoords,
		props.parkingCoords,
		map,
		props.mapVisible,
	]);


	const zoom = 12;

	let lineSymbol = {
		path: 'M 0,-1 0,1',
		strokeOpacity: 1,
		scale: 4,
		strokeColor: 'red',
	};

	const onApiLoaded = (_map) => {
		// eslint-disable-next-line no-undef
		const _walkingDisplay = new google.maps.DirectionsRenderer({
			polylineOptions: {
				strokeOpacity: 0,
				icons: [
					{
						icon: lineSymbol,
						offset: '0',
						repeat: '20px',
					},
				],
			},
		});
		// eslint-disable-next-line no-undef
		const _drivingDisplay = new google.maps.DirectionsRenderer();
		// eslint-disable-next-line no-undef
		const _directionsService = new google.maps.DirectionsService();
		setWalkingDisplay(_walkingDisplay);
		setDrivingDisplay(_drivingDisplay);
		setDirectionsService(_directionsService);
		setMap(_map);
	};

	const drawDirections = () => {
		if (!map) return;
		clearMap();
		drawDriveRoute(map, props.origCoords, props.parkingCoords);
		drawWalkingRoute(map, props.parkingCoords, props.destinationCoords);
	};

	const clearMap = () => {
		if (walkingDisplay) {
			walkingDisplay.setMap(null);
			// walkingDisplay.setDirections(null);
		}
		if (drivingDisplay) {
			drivingDisplay.setMap(null);
			// drivingDisplay.setDirections(null);
		}
	};

	const validateGeoCords = (start, end) =>
		!(!start || !start.lat || !start.lng || !end || !end.lat || !end.lng);

	const createRequest = (travelMode, origin, destination) => ({
		origin,
		destination,
		travelMode,
	});

	const drawDriveRoute = (map, start, end) => {
		drawRoute(
			map,
			drivingDisplay,
			directionsService,
			'DRIVING',
			start,
			end
		);
	};

	const drawWalkingRoute = (map, start, end) => {
		drawRoute(
			map,
			walkingDisplay,
			directionsService,
			'WALKING',
			start,
			end
		);
	};

	const drawRoute = (
		map,
		routeDisplay,
		directionsService,
		mode,
		start,
		end
	) => {
		if (!validateGeoCords(start, end)) return;
		routeDisplay.setMap(map);
		directionsService.route(createRequest(mode, start, end), function(
			result,
			status
		) {
			if (status == 'OK') {
				routeDisplay.setDirections(result);
				let directions = Object.assign({}, directionInstructions);
				directions[mode] = result;

				console.log(mode, directions);
				if(mode === 'DRIVING') {
					setDrivingSteps(directions);
				} else {
					setWalkingSteps(directions);
				}

				// setDirectionInstructions(directions)
			}
		});
	};

	return (
		<div
			className="directionModalBlock modal fade"
			id="directionModal"
			tabIndex="-1"
			role="dialog"
			aria-labelledby="directionModal"
			aria-hidden="true"
		>
			<div className="modal-dialog modal-dialog-centered" role="document">
				<div className="modal-content">
					<div className="modal-header border-0">
						<div className="modal-title" />
						<span aria-hidden="true" data-dismiss="modal">
							&times;
						</span>
					</div>
					<div className="modal-body" id="directions-modal">
						<div className="directionModalBlock-searchArea">
							<div className="directionModalBlock-startingLocation search-field">
								<div className="addressSearchBar-react mb-4">
									<AddressSearchBar
										preventFetchingResults={false}
										useCurrentLocation={false}
										getAddress={props.originPoint}
										onSelect={props.setOriginPoint}
										queryToUpdate="startaddress"
										setUserLocation={props.setOrigCoords}
									/>
								</div>
							</div>
							<div className="separator-icon">
								<span className="sr-only">Wilson Parking</span>
							</div>
							<div className="directionModalBlock-destination search-field">
								<div className="addressSearchBar-react mb-4">
									<AddressSearchBar
										preventFetchingResults={false}
										useCurrentLocation={false}
										getAddress={props.destinationPoint}
										onSelect={props.setDestinationPoint}
										queryToUpdate="address"
										setUserLocation={
											props.setDestinationCoords
										}
									/>
								</div>
							</div>
							{/* <button
								className="directionModalBlock-btn"
								data-toggle="modal"
								data-target="#directionModal"
							>
								Show Directions
							</button> */}
						</div>
						<img
							className="map-icon d-none"
							src="../../assets/svgs/map-icon.svg"
						/>
						<div
							className="directionModalBlock-map"
							id="map-holder"
						>
							<GoogleMapReact
								bootstrapURLKeys={{key: getGoogleApi()}}
								center={props.parkingCoords}
								defaultZoom={zoom}
								yesIWantToUseGoogleMapApiInternals
								onGoogleApiLoaded={({map, maps}) =>
									onApiLoaded(map, maps)
								}
								className="googleMapReact"
								// onChildClick={onChildClick}
								// onChange={onMapChange}
							/>

						</div>
						{props.mapVisible && <DirectionSteps
								drivingSteps={drivingSteps}
								walkingSteps={walkingSteps}
								{...props}
							/>
							}
					</div>
				</div>
			</div>
		</div>

	);
};

export default DirectionModalBlock;
